import React from "react";
import { BrowserRouter as Router, Route, Switch, withRouter } from "react-router-dom";
import "./App.css";
import Nav from "./components/Nav/Nav";
import Home from "./pages/Home";
import Team from "./pages/Team";
import User from "./pages/User";
import Continue from "./pages/Continue";
import New from "./pages/New";
import World from "./features/world";
// import Store from "./config/store";
import CastleGame from "./pages/CastleGame";
import ForestGame from "./pages/ForestGame";
import VillageGame from "./pages/VillageGame";
import LakeBedGame from "./pages/LakeBedGame";
import DragonCaveGame from "./pages/DragonCaveGame";
import CliffGame from "./pages/CliffGame";
import InnerCastle from "./pages/InnerCastle";
import ForestStore from "./pages/ForestStore"
import ComingSoon from "./components/ComingSoon/ComingSoon";
import YouWin from "./components/ComingSoon/YouWin";
import NoMatch from "./pages/NoMatch";

function App() {
  return (
    <Router>
      <div>
        <Nav />
        <RoutedGameWindow />
      </div>
    </Router>
  );
}

function AppRoutes({ location }) {
  return (
    <Switch location={location}>
          <Route exact path={["/", "/react-rpg"]}>
            <Home />
          </Route>

            <Route exact path="/team">
              <Team />
            </Route>

            <Route path="/user/:id?">
              <User />
            </Route>

            <Route path="/continue/:id?">
              <Continue />
            </Route>

            <Route path="/new/:id?">
              <New />
            </Route>

            <Route path="/castle/:id?">
              <CastleGame />
            </Route>

            <Route path="/forest/:id?">
              <ForestGame />
            </Route>

            <Route path="/village/:id?">
              <VillageGame />
            </Route>

            <Route path="/lake-bed/:id?">
              <LakeBedGame />
            </Route>

            <Route path="/dragon-cave/:id?">
              <DragonCaveGame />
            </Route>

            <Route path="/store/:id?">
              <ForestStore />
            </Route>

            <Route path="/cliffs/:id?">
              <CliffGame />
            </Route>

            <Route path="/throne/:id?">
              <InnerCastle />
            </Route>

            <Route path="/youlose/:id?">
              <ComingSoon />
            </Route>

            <Route path="/youwin/:id?">
              <YouWin />
            </Route>

            <Route path="/test" component={WorldPage}/>
            <Route component={NoMatch} />
    </Switch>
  );
}

function GameWindow({ location }) {
  return (
    <main className="game-window">
      <AppRoutes location={location} />
    </main>
  );
}

const RoutedGameWindow = withRouter(GameWindow);

export default App;

const WorldPage  = () => (<div id="this-window"><World /></div>)
